import { useState } from "react";
import "../Theme/light.css";
import "../Theme/dark.css";
import "../Theme/media_queries.css";

import Intro from "./intro.js";
import ContactForm from "./contact_form.js";
import WorkEthicsAndJourney from "./work_ethics_journey.js";
import EnglishText from "../TextContent/english.json";
import GermanText from "../TextContent/deutsch.json";
import PortfolioHeader from "../Components/PortfolioHeader.js";
import LeftImageNav from "../Components/PortfolioLeftNav.js";
import RightDetailsNav from "../Components/PortfolioRightNav.js";
import ThemeSwitcher from "../Components/ThemeSwitcher.js";
import SkillsAndTech from "./skills_and_tech.js";

export default function FullPortfolio() {

    let storedActiveLanguage = localStorage.getItem("saved_lang") || "english";
    let storedActiveTheme = localStorage.getItem("saved_theme") || "light";

    const allLanguages = {
        "german": GermanText,
        "english": EnglishText
    }

    let [activeLanguage, setActiveLanguage] = useState(storedActiveLanguage);
    let [activeLanguageText, setActiveLanguageText] = useState(allLanguages[storedActiveLanguage]);


    
    const myIntro = activeLanguageText.intro;
    const personalDetails = activeLanguageText.personal;
    const mySkills = activeLanguageText.skills;
    const section_headings = activeLanguageText.section_headings;
    const resume_file = activeLanguageText.resume_file;
    const after_contact_submitted = activeLanguageText.after_contact_submitted;
    
    const work_ethics = activeLanguageText.work_ethics;

    
    const myJourney = activeLanguageText.journey;
    

    let [activeTheme, setActiveTheme] = useState(storedActiveTheme); // true is light, false is dark

    const triggerColorTheme = (val) => {

        setActiveTheme(val);

        localStorage.setItem("saved_theme", val);
    }

    const switchCurrentLanguage = (inputVal) => {

        setActiveLanguage(inputVal);

        setActiveLanguageText(allLanguages[inputVal]);

        localStorage.setItem("saved_lang", inputVal);

    }

    return (
        <>

            <div className={`header-navs ${activeTheme}`}>

                <PortfolioHeader section_headings={section_headings} />

                <LeftImageNav />
                <RightDetailsNav personalDetails={personalDetails} />

                <ThemeSwitcher
                    triggerTheme={triggerColorTheme}
                    activeTheme={activeTheme}
                    switchCurrentLanguage={switchCurrentLanguage}
                    activeLanguage={activeLanguage}
                />

            </div>

            <main className={`main ${activeTheme}`}>

                <Intro myIntro={myIntro} section_headings={section_headings} resume_file={resume_file} />

                <SkillsAndTech mySkills={mySkills} section_headings={section_headings} />

                <WorkEthicsAndJourney myJourney={myJourney} section_headings={section_headings} work_ethics={work_ethics} />
                
               {/*  <ContactForm section_headings={section_headings} afterContactSubmitted={after_contact_submitted} /> */}

            </main>
        </>

    )
} 
